import styled from "styled-components";

export const ValuesHeader = styled.tr`
  text-align: center;
`;
